import Vue from 'vue'

const vm = new Vue()

// 发送短信验证码
export function getVerificationCode (params) {
  return vm.$http.post('/c/api/getVerificationCode', params)
}

// 密码模式获取token进行登录
export function getToken (params) {
  return vm.$http.post('oauth/token?client_id=' + encodeURIComponent(params.client_id) + '&client_secret=' + encodeURIComponent(params.client_secret) + '&grant_type=password&username=' + encodeURIComponent(params.username) + '&password=' + encodeURIComponent(params.password))
}
// 获取userId
export function getUserId (params) {
  return vm.$http.get('/i/api/getUserId/' + params + '')
}
// 获取用户信息
export function getUserInfo (params) {
  return vm.$http.get('/i/api/getUserInfo/' + params)
}

// 注册
export function newRegisterUser (params) {
  return vm.$http.post('/c/api/newRegisterUser', params)
}

// 重置密码
export function resetPwd (params) {
  return vm.$http.post('/c/api/resetPwd', params)
}
